export default __webpack_public_path__ + "static/media/calendarSchedule.2aef0874.svg";